import React from 'react';

import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';

import { ReactComponent as CancelIcon } from '../../../../common/assets/icons/cancel_icon_light_gray.svg';
import { SelectableCode } from '../../../../common/types/Codes';

type UseButtonProps = {
  loading: boolean;
  didTapFlagCode: () => void;
  code: SelectableCode;
};

export const FlagButton: React.FC<UseButtonProps> = ({
  loading,
  didTapFlagCode,
  code,
}) => {
  return (
    <LoadingButton
      loading={loading}
      onClick={didTapFlagCode}
      disableElevation
      sx={{
        borderRadius: '40px',
        flexShrink: 0,
        border: '1px solid #D9E9ED',
      }}
      startIcon={
        !code.isFlagged ? (
          <CancelIcon fill='#002145' fillOpacity={0.45} />
        ) : (
          <CancelIcon fill='#FFFFFF' fillOpacity={1} />
        )
      }
      variant={!code.isFlagged ? 'outlined' : 'contained'}
      color={!code.isFlagged ? 'appGray' : 'error'}
    >
      <Typography
        noWrap
        color={!code.isFlagged ? 'darkBlue' : 'white'}
        fontWeight={500}
      >
        Flag
      </Typography>
    </LoadingButton>
  );
};
